import RestModule from "../RestModule";

export default new RestModule("loans", {
  evaluatingPrice: false,
});
